import { Task } from './task';

export const TASKS: Task[] = [
  {
    title: '',
    category: '',
    description: '',
    member: ['Patrick Lindqvist', 'Anna Kindblom']
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/kanban/components/monday-tasks/monday-tasks/tasks.ts